import { useState, useEffect } from 'react'
import api from 'utils/api'

export default ({ id }) => {
  const [kid, setKid] = useState([])
  const [error, setError] = useState(false)
  const [fetching, setFetching] = useState(false)

  useEffect(() => {
    setFetching(true)
    api(`kids/${id}`)
      .then(({ data }) => {
        setFetching(false)
        setKid(data)
      })
      .catch(() => {
        setFetching(false)
        setError(true)
      })
  }, [id])

  const updateChore = ({ choreId, is_completed }) =>
    new Promise((resolve, reject) =>
      api
        .patch(`/chores/${choreId}`, { is_completed })
        .then(() => resolve())
        .catch(() => reject())
    )

  return {
    data: kid,
    error,
    fetching,
    updateChore,
  }
}
